import { FunctionComponent } from 'react';

type LinearProgressProps = {
  /**
   * Render in normal flow instead of pinned to the viewport. Only needed where
   * the bar should belong to a specific panel rather than the page; note that
   * an in-flow bar reintroduces the layout shift, since call sites mount and
   * unmount it as loading toggles.
   */
  inline?: boolean,
}

// Indeterminate top-of-page progress bar. `indeterminate` keyframe is defined
// in tailwind.config.js.
//
// Fixed to the top of the viewport by default rather than sitting in flow.
// Call sites render it as `{loading && <LinearProgress />}`, so an in-flow bar
// was inserted and removed on every fetch - it used to be `-mt-2 relative h-1`,
// a net 4px shift that made tabs below it jump each time loading started or
// stopped. Out of flow it occupies no layout space and nothing moves.
//
// z-index sits above the dialog backdrop (1300), so the ~4 call sites that
// render this inside a dialog still show it; it appears at the top of the
// screen rather than inside the dialog body.
const LinearProgressUI: FunctionComponent<LinearProgressProps> = ({ inline = false }) => {
  const track = 'h-1 overflow-hidden bg-primary/20';
  return (
    <div
      role="progressbar"
      aria-label="Loading"
      className={inline ? `relative w-full ${track}` : `fixed inset-x-0 top-0 z-[1350] ${track}`}
    >
      <div className="absolute inset-y-0 left-0 w-1/3 animate-[indeterminate_1.5s_ease-in-out_infinite] bg-primary" />
    </div>
  );
};

export default LinearProgressUI;
